export enum AdyenTenderOptionsEnum {
  Tipping = 'AskGratuity'
}
